import { doc, updateDoc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

// Script to setup founder role for your account
export const setupFounderRole = async (userEmail = 'ericbell1997@gmail.com') => {
  try {
    console.log('Setting up founder role for:', userEmail);
    
    // You'll need to run this with your actual user ID
    // For now, let's create a function that you can call from the console
    
    // This would need your actual Firebase Auth UID
    const userId = 'YOUR_ACTUAL_USER_ID'; // Replace with your actual UID from Firebase Auth
    
    const userRef = doc(db, 'users', userId);
    
    // Check if user exists
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      // Update existing user with founder role
      await updateDoc(userRef, {
        role: 'founder',
        roleAssignedBy: 'system',
        roleAssignedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        email: userEmail,
        displayName: userDoc.data().displayName || 'Eric Bell',
      });
      console.log('✅ Founder role assigned successfully!');
    } else {
      // Create new user document with founder role
      await setDoc(userRef, {
        role: 'founder',
        roleAssignedBy: 'system',
        roleAssignedAt: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        email: userEmail,
        displayName: 'Eric Bell',
      });
      console.log('✅ User created with founder role!');
    }
    
    return { success: true, message: 'Founder role setup complete' };
  } catch (error) {
    console.error('❌ Error setting up founder role:', error);
    return { success: false, error: error.message };
  }
};

// Helper function to run from browser console
window.setupFounder = setupFounderRole;

export default setupFounderRole; 